<template>
    <div class="picker-column" @touchstart="start" @touchmove="move" @touchend="end">
        <div class="picker-cell-list" :class="{animation}" :style="{transform: `translateY(${y}px)`}">
            <div class="picker-cell-item" v-for="(item, i) in range" :key="i">{{item}}</div>
        </div>
        <div class="picker-column-mask"></div>
        <div class="picker-column-select"></div>
    </div>
</template>

<script>
    // 惯性常亮
    const A = 0.003;
    export default {
        name: "picker-column",
        props: {
            range: Array,
            index: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                height: 240,
                itemHeight: 48,
                y: 96, // 纵向偏移 初始为第一个
                animation: false,
                timestamp: null,
                sy: null, // 滑动速度计算距离
                cy: null, // 滑动过程中上次滑动的Y坐标
                oy: 0, // 滑动过程中本次Y坐标与上次Y坐标之间的偏移量 用于判断滑动方向
                position: null, // 滑动起始纵向偏移量
                ori: null, // 滑动起始Y坐标
            }
        },
        mounted() {
            this.setHeight();
        },
        methods: {
            setHeight() {
                let index = this.index;
                let dom = this.$el;
                this.height = dom.clientHeight;
                this.itemHeight = this.height / 5;
                this.y = (2 - index) * this.itemHeight;
            },
            start(e) {
                this.timestamp = Date.now();
                this.cy = this.ori = e.targetTouches[0].pageY;
                this.animation = false;
                this.position = this.y;
                this.oy = 0;
                this.sy = 0;
            },
            move(e) {
                e.preventDefault();
                let y = e.targetTouches[0].pageY;
                let oy = y - this.cy;
                // 方向发生改变 重置起始时间及坐标 用于同一个方向的惯性移动计算
                if(oy * this.oy < 0) {
                    this.timestamp = Date.now();
                    this.sy = 0;
                } else {
                    this.sy += oy;
                }
                this.cy = y;
                let offset = y - this.ori;
                this.y = this.position + offset;
            },
            end(e) {
                e.preventDefault();
                let ih = this.itemHeight;
                let offset = this.y - this.position;
                let sy = this.sy;
                let timeOffset = Date.now() - this.timestamp;
                // 手指滑动速度 px/ms
                let speed = sy / timeOffset;
                // 根据牛顿第一定律计算 惯性移动距离
                let inertia = Math.pow(speed, 2) / A;
                // 根据滑动方向增加惯性移动距离
                if(sy > 0) {
                    offset += inertia;
                } else if(sy < 0) {
                    offset -= inertia;
                }
                // 四舍五入计算滑动到那个元素
                let num = Math.round(offset / ih);
                let y = this.position + num * ih;
                let top = 2 * ih;
                let bottom = (3 - this.range.length) * ih;
                //超出边界范围回弹到边界
                if(y > top) {
                    y = top;
                } else if(y < bottom) {
                    y = bottom;
                }
                this.animation = true;
                this.y = y;
                setTimeout(() => {
                    let num = Math.round((y - this.position) / ih);
                    if(num != 0) {
                        let index = this.index - num;
                        this.$emit("update:index", index);
                    }
                }, 300);
            }
        }
    }
</script>

<style lang="less">
    .picker-column {
        position: relative;
        height: 100%;
        background-color: var(--back-white-color);
        overflow: hidden;
    }
    .picker-cell-list {
        transition: transform ease 0s;
        &.animation {
            transition-duration: .3s;
        }
    }
    .picker-cell-item {
        height: 96px;
        line-height: 96px;
        text-align: center;
        font-size: 32px;
    }
    .picker-column-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: linear-gradient(180deg, rgba(255,255,255,0.95),rgba(255,255,255,0.6)),linear-gradient(0deg,rgba(255,255,255,0.95),rgba(255,255,255,0.6));
        background-position: top,bottom;
        background-size: 100% 192px;
        background-repeat: no-repeat;
    }
    .picker-column-select {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto 0;
        height: 96px;
        border-top: 1px solid rgba(0,0,0,.1);
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
</style>
